import dayjs from "dayjs";
import { GroupedD2DOrder } from "./orderGrouping";

const getDateValue = (dateRequested: string | undefined | null): number => {
  if (!dateRequested) return Number.NEGATIVE_INFINITY;
  const date = dayjs(dateRequested);
  return date.isValid() ? date.valueOf() : Number.NEGATIVE_INFINITY;
};

export const sortD2DOrdersDefault = (
  orders: GroupedD2DOrder[]
): GroupedD2DOrder[] =>
  [...orders].sort((a, b) => {
    const aStatusRank = a.status === "NEW" ? 0 : 1;
    const bStatusRank = b.status === "NEW" ? 0 : 1;
    if (aStatusRank !== bStatusRank) return aStatusRank - bStatusRank;
    return getDateValue(b.dateRequested) - getDateValue(a.dateRequested);
  });
